import { avatarToneClass, initialsOf, nameFromEmail } from "@/lib/people";
import { cn } from "@/lib/utils";

/**
 * Initials avatar. `mine` uses the accent-tinted suite avatar (same as the top
 * bar); everyone else gets a stable pastel from their email. Decorative — put
 * the person's name in adjacent text or on the wrapper.
 */
export function PersonAvatar({
    email,
    name,
    mine,
    size = 22,
    ring,
    className
}: {
    email: string;
    /** Display name when known; otherwise derived from the email. */
    name?: string;
    mine?: boolean;
    size?: number;
    /** A card-coloured ring, for overlapping stacks. */
    ring?: boolean;
    className?: string;
}) {
    return (
        <span
            aria-hidden
            className={cn(
                "inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold leading-none",
                mine ? "suite-avatar" : avatarToneClass(email),
                ring && "ring-2 ring-card",
                className
            )}
            style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.4)) }}
        >
            {initialsOf(name ?? nameFromEmail(email))}
        </span>
    );
}
